import React from "react";
import { motion } from "framer-motion";
import { whatsappLink } from "../lib/constants";

export default function WhatsAppFAB() {
  return (
    <a
      data-testid="whatsapp-fab"
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex h-16 w-16 items-center justify-center"
      aria-label="WhatsApp"
    >
      {/* pulse ring */}
      <span className="pointer-events-none absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-pulse-ring" />
      <span className="pointer-events-none absolute inset-2 rounded-full bg-[#25D366] opacity-40 animate-pulse-ring" style={{ animationDelay: "0.4s" }} />

      <motion.span
        whileHover={{ scale: 1.08, rotate: -6 }}
        whileTap={{ scale: 0.95 }}
        className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)]"
      >
        {/* WhatsApp glyph */}
        <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.58c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.14-.42-2.18-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.61-1.46-.83-2-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.63 1.11 2.81.13.18 1.91 2.92 4.62 4.09.65.28 1.15.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.31zM16.04 4C9.4 4 4 9.4 4 16.04c0 2.12.55 4.18 1.6 6L4 28l6.13-1.6c1.74.95 3.7 1.45 5.91 1.45h.01c6.63 0 12.04-5.4 12.04-12.04 0-3.21-1.25-6.23-3.52-8.5C22.27 5.25 19.25 4 16.04 4z"/>
        </svg>
      </motion.span>
    </a>
  );
}
